import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import * as Glob from "../../../Globale";
import { Trad } from "../../../components/";

const useStyles = makeStyles(theme => ({
    closeButton: {
        position: "absolute",
        right: theme.spacing(2),
        top: theme.spacing(2),
        color: theme.palette.grey[500]
    },
    warning: {
        background: theme.palette.warning.light
    },
    info: {
        background: theme.palette.info.light
    },
    success: {
        background: theme.palette.success.light
    },
    error: {
        background: theme.palette.error.main
    }
}));

interface IAlertDialogProps {
    Data: Glob.CDialog;
    SetDialog: (v: Glob.CDialog) => void;
}

export const _AlertDialog: React.FC<IAlertDialogProps> = ({ Data, SetDialog }) => {
    const classes = useStyles();
    const closeAlert = () => {
        SetDialog(new Glob.CDialog());
    };

    return (
        <Dialog fullWidth maxWidth="xs" open={Data.Open} onClose={closeAlert} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
            <DialogTitle id="alert-dialog-title" className={classes[Data.Type]}>
                <Typography variant="subtitle2" component="p">
                    {Trad.Trad(Data.Title)}
                </Typography>
                <IconButton aria-label="close" className={classes.closeButton} onClick={closeAlert} size="small">
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <DialogContentText id="alert-dialog-description">
                    <Typography variant="body2" component="span">
                        {Data.Content}
                    </Typography>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={closeAlert} color="primary">
                    {Trad.Trad("Chiudi")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/common/AlertDialog.tsx